import { t } from 'i18next';
import * as yup from 'yup';

import { PartNoteType } from 'bom/components/AddPartNote/enums';
import { numberSchemaWithTransform } from 'core/yup';

export const upsertItemSchema = () =>
  yup.object({
    part: yup
      .object({
        number: yup.string().label(t('labelPartNumber')).nullable().required(t('labelPartNumber')),
      })
      .label(t('labelPartNumber'))
      .nullable()
      .required(),
    manufacturer: yup.object().label(t('labelManufacturer')).nullable(),
    description: yup.string().label(t('labelDescription')).nullable(),
    quantity: numberSchemaWithTransform()
      .label(t('labelQuantity'))
      .min(0, t('labelQuantity'))
      .required(),
    uom: yup.string().label(t('labelUom')).nullable().required(),
    notes: yup
      .array()
      .of(
        yup.object().shape({
          content: yup.string().required(),
          type: yup.string().oneOf(Object.values(PartNoteType)).required(),
        })
      )
      .label(t('labelNotes'))
      .nullable(),
  });
